import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import { Box, Stack, Tooltip, Typography, useTheme } from "@mui/material";
import { ChartsLabelMark, useLegend } from "@mui/x-charts";

import { getUnitUsageColor } from "~/utils/unitUsageHelpers";
import { TotalUsageType } from "./DashboardPPTCharts";

const TotalUsageLegend = ({ hideExpectedUsage, totalUsage }: { hideExpectedUsage?: boolean; totalUsage: TotalUsageType }) => {
  const theme = useTheme();
  const { items } = useLegend();

  return (
    <Stack direction="row" gap={1} px={1}>
      {items.map((item) => {
        const { label, id, color: origColor, seriesId, markType } = item;

        let color = origColor;
        if (seriesId === "usedUnits" && totalUsage) {
          const rawColor = getUnitUsageColor(totalUsage.unitUsagePercentage, theme);
          color = typeof rawColor === "function" ? rawColor(theme) : rawColor;
        }

        return (
          <Box
            key={id}
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
            }}
          >
            <ChartsLabelMark color={color} type={markType} />
            <Typography sx={{ display: "inline-block" }}>{`${label}`}</Typography>
          </Box>
        );
      })}
      {!hideExpectedUsage && (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
          }}
        >
          <ChartsLabelMark color={theme.palette.error.main} type="line" />
          <Typography sx={{ display: "inline-block" }}>Expected Usage</Typography>
          <Tooltip title="The target unit usage to date">
            <HelpOutlineIcon fontSize="small" sx={{ color: theme.palette.grey[600], verticalAlign: "middle", cursor: "help" }} />
          </Tooltip>
        </Box>
      )}
    </Stack>
  );
};

export default TotalUsageLegend;
